import Notification from '../../shared/notification';
import { View }  from './view';

import loginFormHndb from '../templates/login.handlebars';

export default class Login extends View {
    constructor(view, data = null, app, { preSubmit = null, postSubmit = null } = {}) {
        super(view);
        this.data = data;
        this.app = app;
        this.form = null;
        this.preSubmit = preSubmit;
        this.postSubmit = postSubmit;
    }

    #listeners = () => {
        this.form.addEventListener('submit', async (e) => {
            e.preventDefault();

            const notification = new Notification({
                type: 'loading',
            });
            notification.open();

            const formData = new FormData(e.target);
            const body = {};

            for (const [key, value] of formData.entries()) {
                body[key] = value;
            }

            if (this.preSubmit) {
                this.preSubmit(body);
            }

            const loginRes = await this.app.service.loginSeller(body);

            if (this.postSubmit) {
                this.postSubmit(loginRes);
            }

            if (loginRes.data) {
                notification.close();
                this.close();
            } else {
                notification.reload({
                    type: 'error',
                    title: loginRes.message
                });
            }
        });

        this.form.addEventListener('click', (e) => {
            if (e.target.value == 'Cancel') {
                this.close();
            }
        });
    };

    open() {
        this.form = this.view.update(loginFormHndb(this.data)).modalContainer;
        this.view.open();
        this.#listeners();
    }
}
